const NoImage = "/assets/images/noimage.jpg";
const TestImage =
  "https://images.pexels.com/photos/1563356/pexels-photo-1563356.jpeg";
const UserImage = "/assets/images/user.png";
const LogImage = "/assets/images/login.png";

const selectData = [
  { value: 1, label: "Alice Carter" },
  { value: 2, label: "Liam Bennett" },
  { value: 3, label: "Sophia Nguyen" },
  { value: 4, label: "Ethan Brooks" },
  { value: 5, label: "Isabella Foster" },
  { value: 6, label: "Noah Hayes" },
  { value: 7, label: "Mia Sullivan" },
  { value: 8, label: "Oliver King" },
  { value: 9, label: "Ava Morgan" },
  { value: 10, label: "James Rivera" },
];
type TableContentData = {
  [key: string]: {
    default: {
      title: string;
      description: string;
    };
    add?: {
      title: string;
      description: string;
    };
    edit?: {
      title: string;
      description: string;
    };
  };
};

const table_content_data: TableContentData = {
  journey: {
    default: {
      title: "Skillshikshya Journey",
      description:
        "Add images to showcase the empowerment of learners at every step!",
    },
  },

  "masterclass-courses-&-batch": {
    default: {
      title: "Masterclass Courses & Batch",
      description: "Manage Course And Batch Information for Masterclasss!",
    },
  },
  "jrp-courses-&-batch": {
    default: {
      title: "JRP Courses & Batch",
      description: "Manage Course And Batch Information for JRP!",
    },
  },
  "success-stories": {
    default: {
      title: "Success Stories",
      description:
        "Showcase our courses and inspire future learners to join the journey!",
    },
  },
  moments: {
    default: {
      title: "Skill-tastic Moments",
      description:
        "Add videos to highlight empowering moments of learners along their journey!",
    },
  },
  "industry-allies": {
    default: {
      title: "Industry Allies",
      description:
        "Add industry collaborations that are shaping the future of skills and innovation!",
    },
  },
  mentors: {
    default: {
      title: "Mentors",
      description:
        "Add mentor profiles to guide learners on their Skillshikshya journey!",
    },
  },
  courses: {
    default: {
      title: "Courses",
      description:
        "Showcase our courses and inspire future learners to join the journey!",
    },
  },
  "courses-categories": {
    default: {
      title: "Courses Categories",
      description:
        "Showcase our courses categories and inspire future learners to join the journey!",
    },
  },
  "courses-duration": {
    default: {
      title: "Courses Duration",
      description:
        "Showcase our courses durations and inspire future learners to join the journey!",
    },
  },
  "courses-batch": {
    default: {
      title: "Courses Batch",
      description:
        "Showcase our courses and batches and inspire future learners to join the journey!",
    },
  },
  "courses-&-batch": {
    default: {
      title: "Manage Course & Batch",
      description:
        "Showcase our courses and inspire future learners to join the journey!",
    },
  },
  "masterclass-courses-categories": {
    default: {
      title: "Masterclass Courses Categories",
      description:
        "No masterclass categories yet — create one to get started!",
    },
  },
  "masterclass-courses-duration": {
    default: {
      title: "Masterclass Courses Duration",
      description:
        "No masterclass durations yet — create one to get started!",
    },
  },
  "masterclass-courses-batch": {
    default: {
      title: "Masterclass Courses Batch",
      description: "No masterclass batches yet — create one to get started!",
    },
  },
  faqs: {
    default: {
      title: "FAQS",
      description:
        "Add key questions and answers to guide learners through their Skillshikshya study journey!",
    },
  },
  testimonials: {
    default: {
      title: "Testimonials",
      description:
        "Add testimonials to showcase Skillshikshya success stories!",
    },
  },
  "enterprise-testimonials": {
    default: {
      title: "Enterprise Testimonials",
      description:
        "Add enterprise testimonials to showcase business success stories!",
    },
  },
  "enterprise-cherish-moments": {
    default: {
      title: "Cherish Moments",
      description:
        "Add cherished moments to celebrate enterprise milestones!",
    },
  },
  "home-cherish-moments": {
    default: {
      title: "Home Cherish Moments",
      description:
        "Add cherished moments to showcase on the home page!",
    },
  },
  careers: {
    default: {
      title: "Career",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
    add: {
      title: "Post a Jobs",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },
  blogs: {
    default: {
      title: "Blogs",
      description:
        "Add blogs to share knowledge and insights with the community!",
    },
  },
  "blogs-category": {
    default: {
      title: "Manage Category",
      description:
        "Showcase our courses and inspire future learners to join the journey!",
    },
  },
  blogsC: {
    default: {
      title: "BlogsC",
      description:
        "Add blogs to share knowledge and insights with the community!",
    },
  },
  "blogsC-category": {
    default: {
      title: "Manage Category C",
      description:
        "Showcase our courses and inspire future learners to join the journey!",
    },
  },
  "request-form": {
    default: {
      title: "Request Form",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },
  "session-inquiry": {
    default: {
      title: "Sessions Inquiry",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },

  bucket: {
    default: {
      title: "Bucket",
      description: "Manage your bucket settings here!",
    },
  },
  enrollment: {
    default: {
      title: "Enrollment",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },
  giveaway: {
    default: {
      title: "Giveaway Enrollment",
      description: "Showcase your enrollment list here!",
    },
  },
  festival: {
    default: {
      title: "Festival Enrollments",
      description: "Showcase the enrollments from any festival page!",
    },
  },
  "manage-source": {
    default: {
      title: "Manage Source",
      description:
        "Showcase our source to understand where the people hear about us from!",
    },
  },
  "microsoft-teams": {
    default: {
      title: "Microsoft Teams License ",
      description: "You can find you microsoft teams email and password below.",
    },
  },
  "giveaway-templates": {
    default: {
      title: "Giveaway Management",
      description: "Create Custom pages for skillshikshya!",
    },
  },
  "contact-form": {
    default: {
      title: "Contact Form",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },
  "masterclass-enrollment": {
    default: {
      title: "Masterclass Enrollment",
      description: "Showcase your Enrollment List here",
    },
  },
  certificates: {
    default: {
      title: "Certificates",
      description: "Customize each template with ease here!",
    },
  },
  branding: {
    default: {
      title: "Branding",
      description: "Define roles and permissions to every team member!",
    },
  },
  "manage-template": {
    default: {
      title: "Manage Template",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },
  logos: {
    default: {
      title: "Logos",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },
  signatures: {
    default: {
      title: "Signature",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },
  stamps: {
    default: {
      title: "Stamps",
      description:
        "Showcase your available roles and attract top talent to join our team!",
    },
  },
  forms: {
    default: {
      title: "Forms",
      description: "Create, Curate, and Keep Your Blogs in Order!",
    },
  },
  "forms-categories": {
    default: {
      title: "Forms",
      description:
        "Showcase our forms and inspire future learners to join the journey!",
    },
  },
  "team-members": {
    default: {
      title: "Team Members",
      description:
        "Introduce your team and inspire future leaders to join the journey!",
    },
  },
  students: {
    default: {
      title: "Student",
      description:
        "Introduce your Students and inspire future leaders to join the journey!",
    },
  },
  "student-placement": {
    default: {
      title: "Student Placement",
      description:
        "Introduce your Students and inspire future leaders to join the journey!",
    },
  },
  "privacy-policy": {
    default: {
      title: "Privacy Policy",
      description: "Manage your privacy policy here!",
    },
  },
  "terms-&-condition": {
    default: {
      title: "Terms and Conditions",
      description: "Manage your terms and conditions here!",
    },
  },
  profile: {
    default: {
      title: "Profile",
      description: " Easily manage and update your profile information here.",
    },
  },
  payment: {
    default: {
      title: "Payment",
      description: " Easily manage and update your payment information here.",
    },
  },
  "payment-mode": {
    default: {
      title: "Payment",
      description: " Easily manage and update your payment information here.",
    },
  },
  "payment-discounts": {
    default: {
      title: "Payment",
      description: " Easily manage and update your payment information here.",
    },
  },
  "activity-log": {
    default: {
      title: "Activity Log",
      description:
        " Easily manage and View  activity log of Team members from here.",
    },
  },
  invoice: {
    default: {
      title: "Invoice",
      description: " Easily manage and update your invoice information here.",
    },
  },
  "payment-payment-mode": {
    default: {
      title: "Payment Mode",
      description: " Easily manage and update your payment modes here.",
    },
  },
  "roles-&-access": {
    default: {
      title: "Roles & Access",
      description: "Define roles and permissions to every team member!",
    },
  },
  "custom-page": {
    default: {
      title: "Custom Page",
      description: "Create Custom pages for skillshikshya!",
    },
  },

  "masterclass-invoice": {
    default: {
      title: "Masterclass Invoice",
      description:
        "Easily manage and update your masterclass information for skillshikshya!",
    },
  },
  "masterclass-payment": {
    default: {
      title: "Masterclass Payment",
      description:
        "Easily manage and update your masterclass payment information for skillshikshya!",
    },
  },
  "jrp-invoice": {
    default: {
      title: "JRP Invoice",
      description:
        "Easily manage and update your jrp invoice information for skillshikshya!",
    },
  },
  "jrp-payment": {
    default: {
      title: "JRP Payment",
      description:
        "Easily manage and update your jrp payment information for skillshikshya!",
    },
  },
  "advertisment-popup": {
    default: {
      title: "Advertisement Popup",
      description: "Manage your advertisement popups here!",
    },
  },
  "masterclass-courses": {
    default: {
      title: "Masterclass Courses",
      description:
        "Easily manage and update your masterclass course information for skillshikshya!",
    },
  },
  "see-courses": {
    default: {
      title: "SEE Courses",
      description:
        "Easily manage and update your masterclass course information for skillshikshya!",
    },
  },
  "plus2-courses": {
    default: {
      title: "Plus 2 Courses",
      description:
        "Easily manage and update your masterclass course information for skillshikshya!",
    },
  },
  "jrp-courses": {
    default: {
      title: "JRP Courses",
      description:
        "Easily manage and update your jrp course information for skillshikshya!",
    },
  },
  "site-settings": {
    default: {
      title: "Site Settings",
      description: "Manage all the Site Settings here ...",
    },
  },
  "match": {
    default: {
      title: "Matches",
      description: "Add and manage upcoming matches to power your Predict & Win campaign."
    }
  },
  "winners": {
    default: {
      title: "Winners",
      description: "Manage user points and profiles with clarity and control."
    }
  },
  "manage-teams": {
    default:{
      title: "Manage Teams",
      description: "Add and manage upcoming matches to power your Predict & Win campaign."
    }
  },
  "user-predictions": {
    default:{
      title: "User Predictions",
      description: "Manage user predictions, points and profiles with clarity and control."
    }
  },
  "user-details": {
    default:{
      title: "User Details",
      description: "Detailed overview of user profile and account information."
    }
  },
  redirects: {
    default: {
      title: "Redirects",
      description: "Manage your website's redirects here."
    }
  },
  "certificate-webhook": {
    default: {
      title: "Certificate Chat Webhook",
      description: "Post certificate cards to a Google Chat space."
    }
  }
};

const bulkType: { [key: string]: string } = {
  "/journey/": "journey",
  "/success-story/": "success-story",
  "/moments/": "moments",
  "/industryallies/": "industry-allies",
  "/mentor/": "mentor",
  "/forms-category/": "forms-category",
  "/duration/": "duration",
  "/faqs/": "faqs",
  "/career/": "career",
  "/testimonial/": "testimonial",
  "/course/": "course",
  "/forms/": "forms",
  "/category/": "category",
  "/blog/": "blog",
  "/certificate/": "certificate",
  "/templates/": "templates",
  "/team-member/": "team-member",
  "/branding/": "branding",
  "/student/": "student",
  "/contactus/": "contactus",
  "/batch/": "batch",
  "/request-form/": "request-form",
  "/email-sent-upcoming-course/": "session-inquiry",
  "/enrollment/": "enrollment",
  "/giveaway-templates/": "giveaway-templates",
  "/source/": "source",
  "/student-placement/": "student-placement",
  "/course-batch/": "course-batch",
  "/payment/": "payment",
  "/paymentmode/": "paymentmode",
  "/invoice/": "invoice",
  "/discount/": "discount",
  "/discount-calculate/": "discount-calculate",
  "/team-members/": "team-members",
  "/groups/": "groups",
  "/custompage/": "custompage",
  "/blog-category/": "blog-category",
  "/custom-gallery/": "custom-gallery",
  "/popup/": "popup",
  "/redirect/": "redirects",
};

const pageViewList: string[] = [
  "blogs",
  "blogsC",
  "forms",
  "careers",
  "courses",
  "masterclass-courses",
  "see-courses",
  "plus2-courses",
  "jrp-courses",
  "success-stories",
  "roles-&-access",
  "manage-template",
  "masterclass-invoice",
  "jrp-invoice",
  "giveaway-templates",
  "privacy policy",
  "terms-&-conditions",
  "custom-page",
  "testimonials",
  "invoice",
  "students",
  "certificate-manage-template",
  "enterprise-testimonials",
  "enterprise-cherish-moments",
  "home-cherish-moments",
];

const table_row = [
  {
    id: 1,
    title: "Understanding React Server Components",
    section: "Frontend",
    category: "Technology",
    featured_image: "https://via.placeholder.com/150/1da077/ffffff?text=React",
    status: "Published",
    author: "Jane Doe",
    created_at: "2024-01-10",
  },
  {
    id: 2,
    title: "10 Tips for a Healthy Lifestyle",
    section: "Wellness",
    category: "Health",
    featured_image: "https://via.placeholder.com/150/f5a623/ffffff?text=Health",
    status: "Draft",
    author: "John Smith",
    created_at: "2024-02-15",
  },
  {
    id: 3,
    title: "Top Travel Destinations in 2025",
    section: "Adventure",
    category: "Travel",
    featured_image: "https://via.placeholder.com/150/4a90e2/ffffff?text=Travel",
    status: "Scheduled",
    author: "Alice Johnson",
    created_at: "2024-03-01",
  },
  {
    id: 4,
    title: "Investing for Beginners",
    section: "Finance",
    category: "Finance",
    featured_image: "https://via.placeholder.com/150/7ed321/ffffff?text=Money",
    status: "Published",
    author: "Robert Brown",
    created_at: "2024-01-25",
  },
  {
    id: 5,
    title: "Modern E-Learning Platforms Compared",
    section: "Education",
    category: "Education",
    featured_image: "https://via.placeholder.com/150/b8e986/000000?text=Learn",
    status: "Archived",
    author: "Emily Davis",
    created_at: "2023-12-10",
  },
  {
    id: 6,
    title: "Best Gaming Consoles in 2025",
    section: "Reviews",
    category: "Gaming",
    featured_image: "https://via.placeholder.com/150/d0021b/ffffff?text=Games",
    status: "Published",
    author: "Michael Clark",
    created_at: "2024-04-05",
  },
  {
    id: 7,
    title: "Premier League 2025 Predictions",
    section: "Sports",
    category: "Sports",
    featured_image: "https://via.placeholder.com/150/8b572a/ffffff?text=Sports",
    status: "Draft",
    author: "Laura Wilson",
    created_at: "2024-05-01",
  },
  {
    id: 8,
    title: "Sustainable Fashion Trends",
    section: "Style",
    category: "Fashion",
    featured_image: "https://via.placeholder.com/150/417505/ffffff?text=Style",
    status: "Published",
    author: "Sophia Lee",
    created_at: "2024-01-18",
  },
  {
    id: 9,
    title: "Gourmet Recipes for Beginners",
    section: "Food",
    category: "Food",
    featured_image: "https://via.placeholder.com/150/9013fe/ffffff?text=Food",
    status: "Scheduled",
    author: "David Martinez",
    created_at: "2024-03-20",
  },
  {
    id: 10,
    title: "Breaking News Analysis",
    section: "Current Affairs",
    category: "News",
    featured_image: "https://via.placeholder.com/150/50e3c2/000000?text=News",
    status: "Published",
    author: "Olivia White",
    created_at: "2024-04-12",
  },
];

const tableCategory = [
  { id: 1, name: "All", count: 6 },
  { id: 2, name: "Clarity", count: 18 },
  { id: 3, name: "Learning", count: 2 },
  { id: 4, name: "Mentor", count: 10 },
  { id: 5, name: "Achieve", count: 0 },
];

const perPageData = [10, 20, 50, 100];
const hideSidebar = ["blogs"];

export {
  NoImage,
  TestImage,
  UserImage,
  selectData,
  LogImage,
  table_content_data,
  pageViewList,
  table_row,
  tableCategory,
  perPageData,
  hideSidebar,
  bulkType,
};
